import { communityLeaderboard } from "../libs/api-url";
import axios from "@/libs/axios";

/**
 * Community Leaderboard Service
 * Handles all "Community Leaderboard" admin API calls.
 *
 * API Endpoints:
 * - GET /api/v1/admin/community-leaderboard/list - Get community leaderboard list
 */
class CommunityLeaderboardService {
  /**
   * @name getList
   * @description Fetches the community leaderboard list from the admin API with pagination and scope.
   * @param {Object} params - Query parameters (scope, page, limit)
   * @returns {Promise<Object>} The response data containing the leaderboard list.
   */
  static async getList(params = {}) {
    try {
      const response = await axios.get(communityLeaderboard.list, { params });
      return response.data;
    } catch (err) {
      throw err;
    }
  }
}

export { CommunityLeaderboardService };
